import { render, staticRenderFns } from "./scrollToTopButton.vue?vue&type=template&id=3215ca55"
import script from "./scrollToTopButton.vue?vue&type=script&lang=js"
export * from "./scrollToTopButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./scrollToTopButton.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports